import { keyframes, css } from 'styled-components';

const animationAnnotationFocusCss = `
    0%, 100% {
        opacity: 1;
    }

    50% {
        opacity: 0.5;
    }
`;
const animationAnnotationFocus = keyframes([
  ``,
  ``
], animationAnnotationFocusCss);
const animateAnnotationFocus = css([
  `animation:`,
  ` 0.3s ease 0s 1 normal none;`
], animationAnnotationFocus);

export { animateAnnotationFocus, animationAnnotationFocus, animationAnnotationFocusCss };
//# sourceMappingURL=animations.js.map
